module.exports = __webpack_public_path__ + "img/logo-footer-new.6ee5dc6a.png";